import { Button, SvgIcon } from '@mui/material';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { func } from 'prop-types';
import React, { memo } from 'react';

const BackButton = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      sx={{ minWidth: 0, minHeight: 0, padding: '6px 7px' }}
      color="secondary"
      variant="outlined"
    >
      <SvgIcon sx={{ fontSize: 24, color: 'primary.dark' }}>
        <ArrowLeftIcon />
      </SvgIcon>
    </Button>
  );
};
BackButton.propTypes = {
  onClick: func.isRequired,
};

export default memo(BackButton);
